import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import * as S from './legal/legalStyles';
import PrivacyContentKo from './legal/PrivacyContentKo';
import PrivacyContentEn from './legal/PrivacyContentEn';

const PrivacyPolicyPage: React.FC = () => {
  const { i18n } = useTranslation();
  const isKo = i18n.language.startsWith('ko');

  return (
    <div style={S.wrap}>
      <div style={S.langToggleBar}>
        <button
          style={S.langToggleBtn}
          onClick={() => i18n.changeLanguage(isKo ? 'en' : 'ko')}
        >
          {isKo ? 'View in English' : '한국어로 보기'}
        </button>
      </div>

      <h1 style={S.h1}>{isKo ? '개인정보처리방침' : 'Privacy Policy'}</h1>
      <p style={S.dateLine}>
        {isKo
          ? '시행일: 2026년 1월 23일 | 최종 수정일: 2026년 1월 23일'
          : 'Effective Date: January 23, 2026 | Last Updated: January 23, 2026'}
      </p>

      {isKo ? <PrivacyContentKo /> : <PrivacyContentEn />}

      <div style={S.footerWrap}>
        <Link to="/" style={{ color: '#007bff', textDecoration: 'none' }}>
          {isKo ? '← 홈으로 돌아가기' : '← Back to Home'}
        </Link>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
